module.exports = __webpack_public_path__ + "media/images/top-content-img-9-26ba21e84bf95dc40e90dec2e2c48bf7.jpg";